import { Injectable } from '@angular/core';
import { HttpHelper } from './http.service';
import { AppConfig } from '../model/config';

@Injectable()
export class DriverScheduleService {

  constructor(
    private readonly http: HttpHelper,
    private readonly configuration: AppConfig) {

  }

  // administration schedules
  public async getAllDriverSchedules(): Promise<any> {

    let url: string = this.configuration.backendUrl + "/api/driverschedule/listSchedules/";

    return await this.http.get(url, () => { },
      () => { }).toPromise<any>();
  }

  public async getDriverSchedule(scheduleName: string): Promise<any> {
    let url: string = this.configuration.backendUrl + "/api/driverschedule/getSchedule/" + scheduleName + "/";
    return await this.http.get(url, () => { },
      () => { }).toPromise<any>();
  }

  public async deleteDriverSchedule(scheduleName: string): Promise<any> {
    let url: string = this.configuration.backendUrl + "/api/driverschedule/deleteSchedule/" + scheduleName + "/";
    return await this.http.get(url, () => { },
      () => { }).toPromise<any>();
  }

  public async uploadDriverSchedule(driverScheduleFile: any): Promise<any> {
    return this.http.put(this.configuration.backendUrl + "/api/driverschedule/uploadfile", driverScheduleFile,
      (result) => {
        console.log('file uploaded');
      },
      (exception) => { }).toPromise<any>();
  }
  
}
